import Common from '../../Common';
import Call from './queuestat/Call';

const QueueStat = class extends Common {
	call: InstanceType<typeof Call>;

	constructor(headers: ApiHeaders) {
		super(headers)

		this.call = new Call(headers);
	}

	async browse(
		companyId: id,
		options: {
			limit?: number,
			limit_from?: number,
			from?: string,
			to?: string,
			weekly_stats?: number,
			weekdays?: [],
			queues?: [],
			users?: [],
		}
	) {
		return this.get(`/company/${companyId}/queuestat${this.getGETVariables(options)}`);
	}
}

export default QueueStat
